namespace $ {
	export class $shm_hitalama_components_drafts_entry extends $giper_baza_entity.with({
		Created: $giper_baza_atom_text,
		Content: $giper_baza_text,
	}) {}
}
